export const ServiceStatuses = {
  DRAFT_QUOTE: 'DraftQuote',
  READY_FOR_SERVICE: 'Ready for Service',
  TRIAL: 'Trial',
  LIVE: 'Live',
  DOWN: 'Down',
  DEGRADED: 'Degraded',
  CANCELLED: 'Cancelled',
  DECOMMISSIONED: 'Decommissioned',
  SUSPENDED: 'Suspended',
  UNVERIFIED: 'Unverified',
  UPDATING: 'Updating',
  PENDING: 'Pending',
  PENDING_PAYMENT: 'PendingPayment',
  UNKNOWN: 'Unknown',
} as const
